import { mapState } from 'pinia'
import { useAuthStore } from '@/store/pinia/auth'
import { useDevStore } from '@/store/pinia/dev'
import { useOrganizationStore } from '@/store/pinia/organization'
import { useProjectStore } from '@/store/pinia/organization/project'
import { useRootStore } from '@/store/pinia/root'

const getters = {
  root: [
    'isEntityOwner',
  ],
  auth: [
    'isAuthenticated',
    'isOrgAdmin',
    'username',
  ],
  organization: [
    'organization',
    'orgCanonical',
    'orgName',
  ],
  dev: [
    '$isBetaFeature',
    '$showDevThings',
    '$showFeature',
  ],
  project: [
    'projectName',
  ],
}

export const globalMapGetters = Object.values(getters).flat()

function mapper (getters) {
  return Object.fromEntries(
    getters.map((getter) => [getter, (state) => state[getter]]),
  )
}

export default {
  /** @param {import('vue').App} app - The Vue instance. */
  install (app) {
    app.mixin({
      computed: {
        ...mapState(useRootStore, mapper(getters.root)),
        ...mapState(useAuthStore, mapper(getters.auth)),
        ...mapState(useOrganizationStore, mapper(getters.organization)),
        ...mapState(useProjectStore, mapper(getters.project)),
        ...mapState(useDevStore, mapper(getters.dev)),
      },
    })
  },
}
